import { DataSource, Layout, Switch, Table} from "@mcleod/components";

export abstract class AutogenLayoutTableCarrierAvailable extends Layout {
	sourceCarrierAvailableOrders: DataSource;
	switchPending: Switch;
	tableAvailable: Table;
}
